export default __webpack_public_path__ + "static/title-gugpung-09d16e33440647290c874e57fd9451da.png";